import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

// THE STRIP ABOVE EVERY LIST (FIN-1297) — the Layout's app-actions-row, built by one rule on every
// page (the grid is in Layout/layout.scss):
//
//   [menu][+] start… |   search (1/5)   | …end [pager]
//
// The menu and "+" come first, always in the same place; the search sits in the middle of the
// strip, a fifth of it wide; the pager is pinned right. A page's other controls go between them:
// what picks the data (period, year, mode) left of the search, the filters and the actions on
// the list right of it. The two sides are equal, so the search is in the middle whatever the
// left holds, and a page without a search or a pager leaves the place empty instead of letting
// the rest move into it.
//
// The Layout renders the frame (ToolbarStripFrame) inside a ToolbarStripProvider; a page — or a
// toolbar the Layout routes — hands its controls to <ToolbarStrip>, which puts each part into its
// place from wherever it renders.
export const SLOTS = ['start', 'search', 'end', 'pagination'];

export const ToolbarSlotsContext = createContext({ slots: {}, refs: {} });

export const ToolbarStripProvider = ({ children }) => {
  const [slots, setSlots] = useState({});
  const refs = useMemo(() => SLOTS.reduce((all, name) => ({
    ...all,
    [name]: (node) => setSlots((current) => (current[name] === node ? current : { ...current, [name]: node })),
  }), {}), []);
  const value = useMemo(() => ({ slots, refs }), [slots, refs]);

  return <ToolbarSlotsContext.Provider value={value}>{children}</ToolbarSlotsContext.Provider>;
};

ToolbarStripProvider.propTypes = { children: PropTypes.node };

export const ToolbarStripFrame = ({ menu }) => {
  const { refs } = useContext(ToolbarSlotsContext);

  return (
    <div className="toolbar-strip">
      <div className="toolbar-strip__side toolbar-strip__side--start">
        {menu}
        <div className="toolbar-strip__start" ref={refs.start} />
      </div>
      <div className="toolbar-strip__search" ref={refs.search} />
      <div className="toolbar-strip__side toolbar-strip__side--end">
        <div className="toolbar-strip__end" ref={refs.end} />
        <div className="toolbar-strip__pagination" ref={refs.pagination} />
      </div>
    </div>
  );
};

ToolbarStripFrame.propTypes = { menu: PropTypes.node };

const ToolbarStrip = (parts) => {
  const { slots } = useContext(ToolbarSlotsContext);

  return SLOTS.map((name) => (parts[name] && slots[name]
    ? <React.Fragment key={name}>{createPortal(parts[name], slots[name])}</React.Fragment>
    : null));
};

ToolbarStrip.propTypes = {
  start: PropTypes.node,
  search: PropTypes.node,
  end: PropTypes.node,
  pagination: PropTypes.node,
};

export default ToolbarStrip;
